export const PULSE_NEW_REPORTS_ON_MAP_KEY = 'pulseNewReportsOnMap';
export const PULSE_NEW_REPORTS_IN_SIDEBAR_KEY = 'pulseNewReportsInSidebar';
export const ARTICLE_CLUSTERING_ENABLED_KEY = 'articleClusteringEnabled';

export const DEFAULT_PULSE_NEW_REPORTS_ON_MAP = true;
export const DEFAULT_PULSE_NEW_REPORTS_IN_SIDEBAR = true;
export const DEFAULT_ARTICLE_CLUSTERING_ENABLED = true;

export const readArticleClusteringFromStorage = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const stored = localStorage.getItem(ARTICLE_CLUSTERING_ENABLED_KEY);

  return stored === 'true';
};

export const writeArticleClusteringToStorage = (value: boolean) => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(ARTICLE_CLUSTERING_ENABLED_KEY, String(value));
};
